import { CLOSE_SITE_AUDIT_REPORT_ALERT, FETCH_ALERTS } from '../actions/alerts'
import {
  SHOW_KEYWORDS_SETUP_ALERT,
  HIDE_KEYWORDS_SETUP_ALERT,
  SHOW_COMPETITORS_SETUP_ALERT,
  HIDE_COMPETITORS_SETUP_ALERT,
} from '../types/alerts'

const initialState = {
  siteAuditReportAlert: null,
  data: null,
}

export default function alertsReducer(state = initialState, action = {}) {
  let resultState = null
  let remainingAlerts
  let existingSetupAlerts

  switch (action.type) {
    case FETCH_ALERTS.success:
      existingSetupAlerts = (state.data || []).filter(
        (alert) =>
          alert.alertType === 'keywords_setup_alert' ||
          alert.alertType === 'competitors_setup_alert',
      )

      resultState = {
        ...state,
        ...action.payload,
        data: [...(action.payload.data || []), ...existingSetupAlerts],
      }
      break
    case CLOSE_SITE_AUDIT_REPORT_ALERT.action:
      resultState = {
        ...state,
        siteAuditReportAlert: null,
      }
      break
    case SHOW_KEYWORDS_SETUP_ALERT:
      return {
        ...state,
        data: [
          ...(state.data || []).filter(
            (alert) =>
              !(
                alert.alertType === 'keywords_setup_alert' &&
                alert.projectId === action.payload.projectId
              ),
          ),
          action.payload,
        ],
      }
    case HIDE_KEYWORDS_SETUP_ALERT:
      remainingAlerts = { ...state.keywordsSetupAlerts }
      if (action.payload?.projectId) {
        delete remainingAlerts[action.payload.projectId]
        return {
          ...state,
          data: (state.data || []).filter(
            (alert) =>
              !(
                alert.alertType === 'keywords_setup_alert' &&
                alert.projectId === action.payload.projectId
              ),
          ),
        }
      }
      return {
        ...state,
        data: (state.data || []).filter(
          (alert) => alert.alertType !== 'keywords_setup_alert',
        ),
      }
    case SHOW_COMPETITORS_SETUP_ALERT:
      return {
        ...state,
        data: [
          ...(state.data || []).filter(
            (alert) =>
              !(
                alert.alertType === 'competitors_setup_alert' &&
                alert.projectId === action.payload.projectId
              ),
          ),
          action.payload,
        ],
      }
    case HIDE_COMPETITORS_SETUP_ALERT:
      remainingAlerts = { ...state.competitorsSetupAlerts }
      if (action.payload?.projectId) {
        delete remainingAlerts[action.payload.projectId]
        return {
          ...state,
          data: (state.data || []).filter(
            (alert) =>
              !(
                alert.alertType === 'competitors_setup_alert' &&
                alert.projectId === action.payload.projectId
              ),
          ),
        }
      }
      return {
        ...state,
        data: (state.data || []).filter(
          (alert) => alert.alertType !== 'competitors_setup_alert',
        ),
      }
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}
